import { render } from "./SitesHeader.vue?vue&type=template&id=f739e486"
import script from "./SitesHeader.vue?vue&type=script&lang=js"
export * from "./SitesHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Adewale\\OneDrive - kochind.com\\Documents\\zoloscan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__